import { curatorStudentsApiSlice } from './curatorStudents'

export type SequentialMode = 'INHERIT' | 'ON' | 'OFF'
export const WITHDRAW_REASONS = ['MOVED', 'MONEY', 'NO_TIME', 'QUALITY', 'OTHER'] as const

// bff: 0 / "" -> null
export interface StudentControlSubject {
    userSubjectEnrollId: number
    subjectId: number | null
    subjectTitleKz: string | null
    subjectTitleRu: string | null
    // null - активен, иначе yyyy-MM-dd
    withdrawnAt: string | null
    withdrawReason: string | null
    withdrawnBy: number | null
    withdrawnByName?: string | null
    returned: boolean
    canManage: boolean
}

export interface StudentControlState {
    userCourseEnrollId: number
    sequentialMode: SequentialMode | null
    sequentialEffective: boolean
    courseSequential: boolean
    canSetSequential: boolean
    subjects: StudentControlSubject[]
}

export interface WithdrawnRow {
    userCourseEnrollId: number
    userSubjectEnrollId: number
    userId: number
    firstName: string | null
    lastName: string | null
    groupId: number | null
    groupTitle: string | null
    subjectId: number | null
    subjectTitleKz: string | null
    subjectTitleRu: string | null
    withdrawnAt: string | null
    withdrawReason: string | null
    note: string | null
    kind: 'WITHDRAWN' | 'RETURNED'
}

export const studentControlApi = curatorStudentsApiSlice
    .enhanceEndpoints({ addTagTypes: ['StudentControl', 'Withdrawn'] })
    .injectEndpoints({
        endpoints: (build) => ({
            fetchStudentControl: build.query<StudentControlState, number>({
                query: (userCourseEnrollId) => ({ url: `student-control/${userCourseEnrollId}` }),
                transformResponse: (response: { data: StudentControlState }) => response.data,
                providesTags: (_r, _e, id) => [{ type: 'StudentControl', id }],
            }),
            setSequentialMode: build.mutation<StudentControlState, { userCourseEnrollId: number; mode: SequentialMode }>({
                query: ({ userCourseEnrollId, mode }) => ({
                    url: `student-control/${userCourseEnrollId}/sequential`,
                    method: 'PUT',
                    body: { mode },
                }),
                invalidatesTags: (_r, _e, { userCourseEnrollId }) => [{ type: 'StudentControl', id: userCourseEnrollId }],
            }),
            markWithdrawn: build.mutation<
                StudentControlState,
                { userCourseEnrollId: number; userSubjectEnrollId: number; date: string; reason: string; note?: string }
            >({
                query: ({ userSubjectEnrollId, date, reason, note }) => ({
                    url: `student-control/subject/${userSubjectEnrollId}/withdraw`,
                    method: 'POST',
                    body: { date, reason, note },
                }),
                invalidatesTags: (_r, _e, { userCourseEnrollId }) => [
                    { type: 'StudentControl', id: userCourseEnrollId },
                    'Withdrawn',
                    { type: 'Student', id: 'LIST' },
                ],
            }),
            restoreWithdrawn: build.mutation<StudentControlState, { userCourseEnrollId: number; userSubjectEnrollId: number }>({
                query: ({ userSubjectEnrollId }) => ({
                    url: `student-control/subject/${userSubjectEnrollId}/restore`,
                    method: 'POST',
                }),
                invalidatesTags: (_r, _e, { userCourseEnrollId }) => [
                    { type: 'StudentControl', id: userCourseEnrollId },
                    'Withdrawn',
                    { type: 'Student', id: 'LIST' },
                ],
            }),
            fetchWithdrawn: build.query<WithdrawnRow[], { courseId?: number; mentorId?: number }>({
                query: (params) => ({ url: `student-control/withdrawn`, params }),
                transformResponse: (response: { data: WithdrawnRow[] | { rows: WithdrawnRow[] } }) => {
                    const data = response.data
                    return Array.isArray(data) ? data : data?.rows ?? []
                },
                providesTags: ['Withdrawn'],
            }),
        }),
    })
